import React from 'react';
import { Tag, Button, Space, Typography } from 'antd';
import { DisconnectOutlined, SyncOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { loadCierre } from 'utils/offlineCierreStore';

const { Text } = Typography;

// Estados en español neutral y NO técnico (regla feedback-espanol-neutral).
export default function CierreOfflineBadge({ mantencionId, onRetry }) {
  const cierre = loadCierre(mantencionId);
  if (!cierre) return null;

  if (cierre.status === 'ENVIANDO') {
    return <Tag icon={<SyncOutlined spin />} color="processing">Enviando…</Tag>;
  }
  if (cierre.status === 'ERROR') {
    return (
      <Space direction="vertical" size={2}>
        <Tag icon={<ExclamationCircleOutlined />} color="error">Requiere revisión</Tag>
        <Text type="secondary">
          {cierre.errorMotivo || 'No se pudo cerrar. Vuelve a intentarlo.'}
        </Text>
        <Button size="small" onClick={() => onRetry && onRetry(mantencionId)}>
          Reintentar
        </Button>
      </Space>
    );
  }
  // PENDIENTE con finishDone: ya cerró en el server, solo falta el envío del informe.
  if (cierre.finishDone) {
    return (
      <Tag icon={<DisconnectOutlined />} color="warning">
        Cerrada — el informe se enviará al recuperar internet
      </Tag>
    );
  }
  // PENDIENTE
  return (
    <Tag icon={<DisconnectOutlined />} color="warning">
      Guardada sin conexión — se enviará al recuperar internet
    </Tag>
  );
}
